import React, { useState } from 'react';

import { AiOutlineClose } from "react-icons/ai";

import fbImg from './../../assets/images/static/facebook.png';
import googleImg from './../../assets/images/static/google.png';

import SignUpModal from './../Modal/SignUpModal';

import {
  Modal,
  ModalContent,
  ModalHeading,
  ModalTitle,
  CloseBtn,
  ModalBody,
  Form,
  ButtonWrapper,
  StyledLoginButton,
  Image,
  Span
} from './styled';

const LoginModal = ({closeModal}) => {

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  }

  return (
      <>
      <Modal>
        <ModalContent>
          <ModalHeading heading="true">
            <ModalTitle>Sign up <br /> for Free Trail</ModalTitle>
            <CloseBtn onClick={() => closeModal(false)}>
              <AiOutlineClose />
            </CloseBtn>
          </ModalHeading>
          <ModalBody>
            <Form>
              <ButtonWrapper>
                <StyledLoginButton
                  onClick={openModal}
                  type='button'
                >
                  <Image src={fbImg} />
                  <Span>Continue with Facebook</Span>
                </StyledLoginButton>
                <StyledLoginButton
                  onClick={openModal}
                  type='button'
                >
                  <Image src={googleImg} />
                  <Span>Sign Up With Google</Span>
                </StyledLoginButton>
              </ButtonWrapper>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
      { showModal && <SignUpModal closeModal={setShowModal} closeLoginModal={closeModal} /> }
    </>
  )
}

export default LoginModal;